import {
  GtmDataLayerEvent,
  gtmDataLayerPushRaw,
  registerDataLayerBeforeHook,
} from "@made-people/grease-gtm";
import { useEffectOnce } from "@made-people/react-use-effect-once";
import { FrontendContextV1 } from "@made-people/nestjs-bff-service";
import { gtmDatalayerPusher } from "./gtm-datalayer-pusher";
import { useCallback } from "react";
import { mmGtmContext } from "./mm-gtm-context";
import { useCountriesAndLanguages } from "@made-people/grease-countries-and-languages";

import { MmGtmEventPageView } from "./event-listeners/mm-gtm-event-page-view";
import { MmGtmEventAddToCart } from "./event-listeners/mm-gtm-event-add-to-cart";
import { MmGtmEventRemoveFromCart } from "./event-listeners/mm-gtm-event-remove-from-cart";
import { MmGtmEventViewItemList } from "./event-listeners/mm-gtm-event-view-item-list";
import { MmGtmEventViewItem } from "./event-listeners/mm-gtm-event-view-item";
import { MmGtmEventSelectItem } from "./event-listeners/mm-gtm-event-select-item";
import { MmGtmEventBeginCheckout } from "./event-listeners/mm-gtm-event-begin-checkout";
import { MmGtmEventPurchase } from "./event-listeners/mm-gtm-event-purchase";
import { MmGtmEventSelectSize } from "./event-listeners/mm-gtm-event-select-size";
import { runAfterCookiebotStatisticsAccepted } from "../../components/global/cookiebot-script";

// TODO: sätt upp eventlyssnare för alla event som finns så de kan
// återimplementeras snyggt

const _ = (props: { frontendContext: FrontendContextV1 }) => {
  const { countries } = useCountriesAndLanguages();
  const pusher = useCallback(
    (data: GtmDataLayerEvent) => {
      gtmDatalayerPusher(data, countries, props.frontendContext);
    },
    [props.frontendContext, countries],
  );

  useEffectOnce(() => {
    // Temporary solution to push the experiment viewed event to GTM
    // while doing the site A/B test
    runAfterCookiebotStatisticsAccepted(() => {
      gtmDataLayerPushRaw({
        event: "experiment_viewed",
        experiment_id: "site-test",
        variation_id: "1",
      });
    });

    registerDataLayerBeforeHook(
      // Simply disable all default datalayer pushes
      () => false,
    );
  });

  return (
    <mmGtmContext.Provider
      value={{
        pusher,
        frontendContext: props.frontendContext,
      }}
    >
      <MmGtmEventPageView />
      <MmGtmEventAddToCart />
      <MmGtmEventRemoveFromCart />
      <MmGtmEventViewItemList />
      <MmGtmEventViewItem />
      <MmGtmEventSelectItem />
      <MmGtmEventBeginCheckout />
      <MmGtmEventPurchase />
      <MmGtmEventSelectSize />
    </mmGtmContext.Provider>
  );
};

export const MmGtmRoot = (props: { frontendContext: FrontendContextV1 }) => {
  return <_ frontendContext={props.frontendContext} />;
};
